import React, { FC } from 'react';

import { useTheme } from 'styled-components';

import Headshot from '@nhl/nhl-react-ui/lib/Headshot';
import headshotTypes from '@nhl/nhl-react-ui/lib/Headshot/headshotTypes';

import { PlayerOption } from '../../types'
import { HeadshotContainer, LabelWrapper, PlayerDetail, PlayerDetails, PlayerInfo, PlayerName } from './styles';

type Props = {
    isSkater: boolean;
    option: PlayerOption;
}

const OptionLabel: FC<Props> = ({ isSkater, option }) => {
    const theme = useTheme();

    // We check the sweater number as well so that we don't set a color to headshots that don't actually have a picture
    // ex) players that are signed to a franchise, but are playing in a different league than the NHL
    const backgroundColor = option.team?.triCode && option.sweaterNumber
        ? theme.Team[option.team.triCode]?.gamecenter
        : theme.Surface.secondary;

    return (
        <LabelWrapper>
            {!option.isSearchValue && (
                <HeadshotContainer
                    $backgroundColor={backgroundColor}
                >
                    <Headshot
                        type={isSkater ? headshotTypes.SKATER : headshotTypes.GOALIE}
                        urlOverride={`https://assets.nhle.com/mugs/nhl/latest/${option.key}.png`}
                        size={40}
                        alt={option.label}
                        backgroundColor={backgroundColor}
                        team={option.team}
                        forceSimpleCircle
                    />
                </HeadshotContainer>
            )}
            <PlayerInfo>
                <PlayerName>{option.label}</PlayerName>
                {option.sweaterNumber && option.team?.triCode &&
                    <PlayerDetails>
                        <PlayerDetail>{option.team?.triCode}</PlayerDetail>&nbsp;&bull;&nbsp;
                        <PlayerDetail>{option.sweaterNumber}</PlayerDetail>&nbsp;&bull;&nbsp;
                        <>{option.positionCode}</>
                    </PlayerDetails>
                }
            </PlayerInfo>
        </LabelWrapper>
    );
}

export default OptionLabel;
